import React from "react";
import { MDCAnchorMenu, MDCButtonIcon, MDCMenu } from "../../library/components/mdc-components"; ////page actions menu

export default class PagesMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var itemStyle = {
      display: 'none'
    };
    if (this.props.showSettings) itemStyle = {};
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: "pagesMenu",
      onMenuSelected: this.props.onMenuSelected
    }, /*#__PURE__*/React.createElement(MDCButtonIcon, {
      icon: "pages",
      label: "Pages",
      active: this.props.active,
      index: "1",
      anchor: "true"
    }), this.props.showFullMenu ? /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "pagesMenu",
      cls: "small"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-create",
      "data-id": "page-create"
    }, "Create Page"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "pages-view",
      "data-id": "pages-view"
    }, "View Pages"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-settings",
      "data-id": "page-settings"
    }, "Page Settings"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-delete",
      "data-id": "page-delete"
    }, "Delete Page"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "dashboard",
      "data-id": "dashboard"
    }, "View Dashboard")) : /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "pagesMenu",
      cls: "small"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-create",
      "data-id": "page-create"
    }, "Create Page"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "pages-view",
      "data-id": "pages-view"
    }, "View Pages"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-settings",
      "data-id": "page-settings",
      style: itemStyle
    }, "Page Settings"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "dashboard",
      "data-id": "dashboard"
    }, "View Dashboard")));
  }

}